import * as React from "react";
import "./pipeline.scss";
import SSOCom from "./pipeline";

import { pipelineobj } from "../../Entity/SSOObj";
export interface IProps {
  data: pipelineobj;
  Probability;
  Phases;
  UpdateMethod;
  LogTitle;
  InsideCRM;
  CRMURL;
  Phrases;
  contactlinks;
  RefreshCRMData;
}
export default class PipelineCalView extends React.Component<IProps> {
  constructor(props) {
    super(props);
  }
  public render() {
    let key = "SSOCalviewKey_" + this.props.data.ID;
    return (
      <div
        className="pipeline"
        draggable
        onDragStart={e => this.onDragStart(e)}
      >
        <div className={["calitem", "ellips"].join(" ")}>
          <SSOCom
            data={this.props.data}
            key={key}
            Probability={this.props.Probability}
            Phases={this.props.Phases}
            UpdateMethod={this.props.UpdateMethod}
            LogTitle={this.props.LogTitle}
            InsideCRM={this.props.InsideCRM}
            CRMURL={this.props.CRMURL}
            Phrases={this.props.Phrases}
            contactlinks={this.props.contactlinks}
            RefreshCRMData={this.props.RefreshCRMData}
          />
        </div>
      </div>
    );
  }
  public onDragStart = ev => {
    /*ev.preventDefault();

        ev.stopPropagation();
        ev.dataTransfer.effectAllowed='move';
        */
    /*
        ev.dataTransfer.setData("id", this.props.data.ID.toString());
        ev.dataTransfer.setData("type", 'pipeline');
        ev.dataTransfer.setData("colno", this.props.data.SSOColmn.toString());
        ev.dataTransfer.setData("property", 'IGlobeCRM_SSO_Followup');
        ev.dataTransfer.setData("source", ev.target.parentElement.id);*/

    let dragdata = {
      id: this.props.data.ID,
      type: "pipeline",
      colno: this.props.data.SSOColmn,
      property: "IGlobeCRM_SSO_Followup",
      source: ev.target.parentElement.id
    };
    ev.dataTransfer.setData("text/plain", JSON.stringify(dragdata));

    /*ev.dataTransfer.setData("text/plain",this.props.data.ID);
        ev.dataTransfer.setData("text/plain", 'crmmeeting');*/
  };
}
/*

*/
